import api from '../api/config';
import {
    adminWhatsNewSeenBody,
    toReleaseMap,
    type ReleaseMap
} from '../components/whats-new/seenRelease';

interface LoginResponse {
    token: string;
}

interface VerifyUser {
    id: string;
    email: string;
    name: string;
    database: {
        data: {
            id: string;
            isAdmin: boolean;
            practices: string[];
            lastSeenRelease?: string | null;
            lastSeenReleases?: ReleaseMap | null;
        };
    };
}

interface VerifyResponse {
    user: VerifyUser;
}

export async function loginUser(email: string, password: string): Promise<LoginResponse> {
    const response = await api.post<LoginResponse>('/user/login', { email, password });
    return response.data;
}

export async function verifyUser(): Promise<VerifyResponse> {
    const response = await api.get<VerifyResponse>('/user/verify');
    return response.data;
}

export async function updatePassword(currentPassword: string, newPassword: string): Promise<void> {
    await api.post('/user/password', { currentPassword, newPassword });
}

export async function updateUserName(fullname: string): Promise<{ name: string }> {
    const response = await api.post<{ name: string; message: string }>('/user/name', { fullname });
    return { name: response.data.name };
}

interface WhatsNewSeenResponse {
    success: boolean;
    lastSeenReleases?: unknown;
}

export async function markWhatsNewSeen(version: string): Promise<ReleaseMap | undefined> {
    const response = await api.post<WhatsNewSeenResponse>(
        '/user/whats-new-seen',
        adminWhatsNewSeenBody(version)
    );
    const releases = response.data?.lastSeenReleases;
    return releases ? toReleaseMap(releases) : undefined;
}
